/* eslint-disable import/prefer-default-export */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FEATURES_TYPES } from '../constants';
import {
  filterFeatureDetails,
  excludeEmptyFeatures,
  makeFullRowIfSameStrings,
  getFeaturesV21,
  getLegacyFeatures,
} from '../helpers';

export const useFeatures = ({ plans, featuresType, hideSMSinfo, isAuCustomer, isGbCustomer, smsStartingPrice }) => {
  const { t } = useTranslation();

  const processedFeatures = useMemo(() => {
    let planFeatures;

    switch (featuresType) {
      case FEATURES_TYPES.V21:
        planFeatures = getFeaturesV21(t, hideSMSinfo, isAuCustomer, isGbCustomer, smsStartingPrice);
        break;
      case FEATURES_TYPES.LEGACY:
        planFeatures = getLegacyFeatures(t);
        break;
      default:
        throw new Error(`Unknown featuresType in ComparisonTable: ${featuresType}`);
    }

    const filteredFeatureDetails = filterFeatureDetails(plans, planFeatures);
    const existingFeatures = excludeEmptyFeatures(plans, filteredFeatureDetails);

    return makeFullRowIfSameStrings(existingFeatures);
  }, [plans, featuresType, t, hideSMSinfo, isAuCustomer, isGbCustomer, smsStartingPrice]);

  return processedFeatures;
};
